import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/overview/')({});